import _definePage_default_0 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/access-designer.vue?definePage&vue'
import _definePage_default_3 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/smart-dashboard.vue?definePage&vue'
import _definePage_default_4 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/app/follow-ups.vue?definePage&vue'
import _definePage_default_5 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/app/visits/[visitName].vue?definePage&vue'
import _definePage_default_6 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/clinic-station.vue?definePage&vue'
import _definePage_default_7 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/customers/territory-insights.vue?definePage&vue'
import _definePage_default_8 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/games/index.vue?definePage&vue'
import _definePage_default_9 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/games/[id].vue?definePage&vue'
import _definePage_default_10 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/games/dashboard.vue?definePage&vue'
import _definePage_default_11 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/games/plays.vue?definePage&vue'
import _definePage_default_12 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/games/prizes.vue?definePage&vue'
import _definePage_default_13 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/games/redeem.vue?definePage&vue'
import _definePage_default_14 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/graveyard/index.vue?definePage&vue'
import _definePage_default_15 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/graveyard/graves/index.vue?definePage&vue'
import _definePage_default_16 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/graveyard/graves/[id].vue?definePage&vue'
import _definePage_default_17 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/clinical-master-data/index.vue?definePage&vue'
import _definePage_default_18 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/clinical-master-data/print/index.vue?definePage&vue'
import _definePage_default_19 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/clinical-master-data/print/settings/index.vue?definePage&vue'
import _definePage_default_20 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/doctor-performance/index.vue?definePage&vue'
import _definePage_default_21 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/settings/index.vue?definePage&vue'
import _definePage_default_22 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/visits/[id].vue?definePage&vue'
import _definePage_default_23 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/his/radiology/index.vue?definePage&vue'
import _definePage_default_24 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/login.vue?definePage&vue'
import _definePage_default_25 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/modules/index.vue?definePage&vue'
import _definePage_default_26 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/not-authorized.vue?definePage&vue'
import _definePage_default_27 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/permission.vue?definePage&vue'
import _definePage_default_28 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/pet-profile/[id]/[tab].vue?definePage&vue'
import _definePage_default_29 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/pos/offline-queue.vue?definePage&vue'
import _definePage_default_30 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/pos/sell.vue?definePage&vue'
import _definePage_default_31 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/queue/display.vue?definePage&vue'
import _definePage_default_32 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/queue/doctor.vue?definePage&vue'
import _definePage_default_33 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/queue/kiosk.vue?definePage&vue'
import _definePage_default_34 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/report-engine/[tab].vue?definePage&vue'
import _definePage_default_35 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/setting/[tab].vue?definePage&vue'
import _definePage_default_36 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/suppliers/index.vue?definePage&vue'
import _definePage_default_37 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/suppliers/[id].vue?definePage&vue'
import _definePage_default_38 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/users/[id]/profile.vue?definePage&vue'
import _definePage_default_39 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/vst-test-page/index.vue?definePage&vue'
import _definePage_default_40 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/vst-test-page/[id].vue?definePage&vue'
import _definePage_default_41 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/returns-monitor.vue?definePage&vue'
import _definePage_default_42 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/smart-dashboard.vue?definePage&vue'
import _definePage_default_43 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-checker.vue?definePage&vue'
import _definePage_default_44 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-count.vue?definePage&vue'
import _definePage_default_45 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-prices/index.vue?definePage&vue'
import _definePage_default_46 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-prices/[id].vue?definePage&vue'
import _definePage_default_47 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-prices/create.vue?definePage&vue'
import _definePage_default_48 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-reconciliations/index.vue?definePage&vue'
import _definePage_default_49 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-reconciliations/[id].vue?definePage&vue'
import _definePage_default_50 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-reconciliations/create.vue?definePage&vue'
import _definePage_default_51 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-transfers/new.vue?definePage&vue'
import _definePage_default_52 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/whatsapp/index.vue?definePage&vue'
import _definePage_default_53 from '/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/whatsapp/[tab].vue?definePage&vue'

export const routes = [
  {
    path: '/',
    name: 'root',
    component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/index.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/access-designer',
    name: 'access-designer',
    component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/access-designer.vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/accounting',
    /* internal name: 'accounting' */
    /* no component */
    children: [
      {
        path: 'account-tree',
        name: 'accounting-account-tree',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/account-tree.vue'),
        /* no children */
      },
      {
        path: 'cashiers',
        /* internal name: 'accounting-cashiers' */
        /* no component */
        children: [
          {
            path: '',
            name: 'accounting-cashiers',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/cashiers/index.vue'),
            /* no children */
          },
          {
            path: 'dashboard',
            name: 'accounting-cashiers-dashboard',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/cashiers/dashboard.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'general-ledger',
        name: 'accounting-general-ledger',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/general-ledger.vue'),
        /* no children */
      },
      {
        path: 'journal-entries',
        /* internal name: 'accounting-journal-entries' */
        /* no component */
        children: [
          {
            path: '',
            name: 'accounting-journal-entries',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/journal-entries/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'accounting-journal-entries-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/journal-entries/[id].vue'),
            /* no children */
          },
          {
            path: 'create',
            name: 'accounting-journal-entries-create',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/journal-entries/create.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'payment-entries',
        /* internal name: 'accounting-payment-entries' */
        /* no component */
        children: [
          {
            path: '',
            name: 'accounting-payment-entries',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/payment-entries/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'accounting-payment-entries-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/payment-entries/[id].vue'),
            /* no children */
          },
          {
            path: 'create',
            name: 'accounting-payment-entries-create',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/payment-entries/create.vue'),
            /* no children */
          },
          {
            path: 'pay',
            name: 'accounting-payment-entries-pay',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/payment-entries/pay.vue'),
            /* no children */
          },
          {
            path: 'receive',
            name: 'accounting-payment-entries-receive',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/payment-entries/receive.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'sales-invoices',
        /* internal name: 'accounting-sales-invoices' */
        /* no component */
        children: [
          {
            path: '',
            name: 'accounting-sales-invoices',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/sales-invoices/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'accounting-sales-invoices-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/sales-invoices/[id].vue'),
            /* no children */
          },
          {
            path: 'create',
            name: 'accounting-sales-invoices-create',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/sales-invoices/create.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'settings',
        name: 'accounting-settings',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/settings.vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: 'smart-dashboard',
        name: 'accounting-smart-dashboard',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/accounting/smart-dashboard.vue'),
        /* no children */
      },
  _definePage_default_3
  )
    ],
  },
  {
    path: '/app',
    /* internal name: 'app' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'follow-ups',
        name: 'app-follow-ups',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/app/follow-ups.vue'),
        /* no children */
      },
  _definePage_default_4
  ),
      {
        path: 'visits',
        /* internal name: 'app-visits' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':visitName',
            name: 'app-visits-visit-name',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/app/visits/[visitName].vue'),
            /* no children */
          },
  _definePage_default_5
  )
        ],
      }
    ],
  },
  {
    path: '/apps',
    /* internal name: 'apps' */
    /* no component */
    children: [
      {
        path: 'invoice',
        /* internal name: 'apps-invoice' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-invoice-list' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-invoice-list',
                component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/apps/invoice/list/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'preview',
            /* internal name: 'apps-invoice-preview' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'apps-invoice-preview-id',
                component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/apps/invoice/preview/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/audit',
    /* internal name: 'audit' */
    /* no component */
    children: [
      {
        path: 'record-history',
        /* internal name: 'audit-record-history' */
        /* no component */
        children: [
          {
            path: '',
            name: 'audit-record-history',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/audit/record-history/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'settlement-differences',
        /* internal name: 'audit-settlement-differences' */
        /* no component */
        children: [
          {
            path: '',
            name: 'audit-settlement-differences',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/audit/settlement-differences/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'system',
        /* internal name: 'audit-system' */
        /* no component */
        children: [
          {
            path: '',
            name: 'audit-system',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/audit/system/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/clinic-station',
    name: 'clinic-station',
    component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/clinic-station.vue'),
    /* no children */
  },
  _definePage_default_6
  ),
  {
    path: '/correspondence',
    /* internal name: 'correspondence' */
    /* no component */
    children: [
      {
        path: '',
        name: 'correspondence',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/correspondence/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: 'correspondence-id',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/correspondence/[id].vue'),
        /* no children */
      },
      {
        path: 'archive',
        /* internal name: 'correspondence-archive' */
        /* no component */
        children: [
          {
            path: '',
            name: 'correspondence-archive',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/correspondence/archive/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'dispatch',
        /* internal name: 'correspondence-dispatch' */
        /* no component */
        children: [
          {
            path: '',
            name: 'correspondence-dispatch',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/correspondence/dispatch/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'inbox',
        /* internal name: 'correspondence-inbox' */
        /* no component */
        children: [
          {
            path: '',
            name: 'correspondence-inbox',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/correspondence/inbox/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'internal',
        /* internal name: 'correspondence-internal' */
        /* no component */
        children: [
          {
            path: '',
            name: 'correspondence-internal',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/correspondence/internal/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'official-letters',
        /* internal name: 'correspondence-official-letters' */
        /* no component */
        children: [
          {
            path: '',
            name: 'correspondence-official-letters',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/correspondence/official-letters/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'outgoing',
        /* internal name: 'correspondence-outgoing' */
        /* no component */
        children: [
          {
            path: '',
            name: 'correspondence-outgoing',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/correspondence/outgoing/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/coupon',
    /* internal name: 'coupon' */
    /* no component */
    children: [
      {
        path: '',
        name: 'coupon',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/coupon/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/crm',
    /* internal name: 'crm' */
    /* no component */
    children: [
      {
        path: '',
        name: 'crm',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/crm/index.vue'),
        /* no children */
      },
      {
        path: 'campaigns',
        /* internal name: 'crm-campaigns' */
        /* no component */
        children: [
          {
            path: '',
            name: 'crm-campaigns',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/crm/campaigns/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'customers',
        /* internal name: 'crm-customers' */
        /* no component */
        children: [
          {
            path: '',
            name: 'crm-customers',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/crm/customers/index.vue'),
            /* no children */
          },
          {
            path: ':doctype',
            /* internal name: 'crm-customers-doctype' */
            /* no component */
            children: [
              {
                path: ':name',
                name: 'crm-customers-doctype-name',
                component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/crm/customers/[doctype]/[name].vue'),
                /* no children */
              }
            ],
          },
          {
            path: ':id',
            name: 'crm-customers-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/crm/customers/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'dashboard',
        /* internal name: 'crm-dashboard' */
        /* no component */
        children: [
          {
            path: '',
            name: 'crm-dashboard',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/crm/dashboard/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'follow-ups',
        /* internal name: 'crm-follow-ups' */
        /* no component */
        children: [
          {
            path: '',
            name: 'crm-follow-ups',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/crm/follow-ups/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'leads',
        /* internal name: 'crm-leads' */
        /* no component */
        children: [
          {
            path: '',
            name: 'crm-leads',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/crm/leads/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'messages',
        /* internal name: 'crm-messages' */
        /* no component */
        children: [
          {
            path: '',
            name: 'crm-messages',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/crm/messages/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'opportunities',
        /* internal name: 'crm-opportunities' */
        /* no component */
        children: [
          {
            path: '',
            name: 'crm-opportunities',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/crm/opportunities/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'pipeline',
        /* internal name: 'crm-pipeline' */
        /* no component */
        children: [
          {
            path: '',
            name: 'crm-pipeline',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/crm/pipeline/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'reports',
        /* internal name: 'crm-reports' */
        /* no component */
        children: [
          {
            path: '',
            name: 'crm-reports',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/crm/reports/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'settings',
        /* internal name: 'crm-settings' */
        /* no component */
        children: [
          {
            path: '',
            name: 'crm-settings',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/crm/settings/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'territories',
        /* internal name: 'crm-territories' */
        /* no component */
        children: [
          {
            path: '',
            name: 'crm-territories',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/crm/territories/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/customers',
    /* internal name: 'customers' */
    /* no component */
    children: [
      {
        path: 'details',
        /* internal name: 'customers-details' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'customers-details-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/customers/details/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'groups',
        /* internal name: 'customers-groups' */
        /* no component */
        children: [
          {
            path: '',
            name: 'customers-groups',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/customers/groups/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'list',
        /* internal name: 'customers-list' */
        /* no component */
        children: [
          {
            path: '',
            name: 'customers-list',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/customers/list/index.vue'),
            /* no children */
          }
        ],
      },
  _mergeRouteRecord(
      {
        path: 'territory-insights',
        name: 'customers-territory-insights',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/customers/territory-insights.vue'),
        /* no children */
      },
  _definePage_default_7
  )
    ],
  },
  {
    path: '/dashboards',
    /* internal name: 'dashboards' */
    /* no component */
    children: [
      {
        path: 'ecommerce',
        name: 'dashboards-ecommerce',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/dashboards/ecommerce.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/delivery-partners',
    /* internal name: 'delivery-partners' */
    /* no component */
    children: [
      {
        path: '',
        name: 'delivery-partners',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/delivery-partners/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: 'delivery-partners-id',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/delivery-partners/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/drivers',
    /* internal name: 'drivers' */
    /* no component */
    children: [
      {
        path: '',
        name: 'drivers',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/drivers/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: 'drivers-id',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/drivers/[id].vue'),
        /* no children */
      },
      {
        path: 'dashboard',
        name: 'drivers-dashboard',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/drivers/dashboard.vue'),
        /* no children */
      },
      {
        path: 'dispatch',
        name: 'drivers-dispatch',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/drivers/dispatch.vue'),
        /* no children */
      },
      {
        path: 'me',
        name: 'drivers-me',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/drivers/me.vue'),
        /* no children */
      },
      {
        path: 'orders',
        name: 'drivers-orders',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/drivers/orders.vue'),
        /* no children */
      },
      {
        path: 'settlement',
        name: 'drivers-settlement',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/drivers/settlement.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/ecommerce',
    /* internal name: 'ecommerce' */
    /* no component */
    children: [
      {
        path: 'category',
        name: 'ecommerce-category',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/ecommerce/category.vue'),
        /* no children */
      },
      {
        path: 'mobile-home',
        name: 'ecommerce-mobile-home',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/ecommerce/mobile-home.vue'),
        /* no children */
      },
      {
        path: 'mobile-home-banners',
        name: 'ecommerce-mobile-home-banners',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/ecommerce/mobile-home-banners.vue'),
        /* no children */
      },
      {
        path: 'product',
        /* internal name: 'ecommerce-product' */
        /* no component */
        children: [
          {
            path: 'add',
            /* internal name: 'ecommerce-product-add' */
            /* no component */
            children: [
              {
                path: '',
                name: 'ecommerce-product-add',
                component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/ecommerce/product/add/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'details',
            /* internal name: 'ecommerce-product-details' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'ecommerce-product-details-id',
                component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/ecommerce/product/details/[id].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'list',
            name: 'ecommerce-product-list',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/ecommerce/product/list.vue'),
            /* no children */
          },
          {
            path: 'variants',
            /* internal name: 'ecommerce-product-variants' */
            /* no component */
            children: [
              {
                path: ':template',
                name: 'ecommerce-product-variants-template',
                component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/ecommerce/product/variants/[template].vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/games',
    /* internal name: 'games' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'games',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/games/index.vue'),
        /* no children */
      },
  _definePage_default_8
  ),
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'games-id',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/games/[id].vue'),
        /* no children */
      },
  _definePage_default_9
  ),
  _mergeRouteRecord(
      {
        path: 'dashboard',
        name: 'games-dashboard',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/games/dashboard.vue'),
        /* no children */
      },
  _definePage_default_10
  ),
  _mergeRouteRecord(
      {
        path: 'plays',
        name: 'games-plays',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/games/plays.vue'),
        /* no children */
      },
  _definePage_default_11
  ),
  _mergeRouteRecord(
      {
        path: 'prizes',
        name: 'games-prizes',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/games/prizes.vue'),
        /* no children */
      },
  _definePage_default_12
  ),
  _mergeRouteRecord(
      {
        path: 'redeem',
        name: 'games-redeem',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/games/redeem.vue'),
        /* no children */
      },
  _definePage_default_13
  )
    ],
  },
  {
    path: '/graveyard',
    /* internal name: 'graveyard' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'graveyard',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/graveyard/index.vue'),
        /* no children */
      },
  _definePage_default_14
  ),
      {
        path: 'graves',
        /* internal name: 'graveyard-graves' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'graveyard-graves',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/graveyard/graves/index.vue'),
            /* no children */
          },
  _definePage_default_15
  ),
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'graveyard-graves-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/graveyard/graves/[id].vue'),
            /* no children */
          },
  _definePage_default_16
  )
        ],
      }
    ],
  },
  {
    path: '/guardians',
    /* internal name: 'guardians' */
    /* no component */
    children: [
      {
        path: 'details',
        /* internal name: 'guardians-details' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'guardians-details-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/guardians/details/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'list',
        /* internal name: 'guardians-list' */
        /* no component */
        children: [
          {
            path: '',
            name: 'guardians-list',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/guardians/list/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/healthcare',
    /* internal name: 'healthcare' */
    /* no component */
    children: [
      {
        path: 'appointments',
        /* internal name: 'healthcare-appointments' */
        /* no component */
        children: [
          {
            path: '',
            name: 'healthcare-appointments',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/appointments/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'healthcare-appointments-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/appointments/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'boarding',
        /* internal name: 'healthcare-boarding' */
        /* no component */
        children: [
          {
            path: '',
            name: 'healthcare-boarding',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/boarding/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'healthcare-boarding-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/boarding/[id].vue'),
            /* no children */
          },
          {
            path: 'records',
            /* internal name: 'healthcare-boarding-records' */
            /* no component */
            children: [
              {
                path: '',
                name: 'healthcare-boarding-records',
                component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/boarding/records/index.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'case-follow-up',
        /* internal name: 'healthcare-case-follow-up' */
        /* no component */
        children: [
          {
            path: '',
            name: 'healthcare-case-follow-up',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/case-follow-up/index.vue'),
            /* no children */
          },
          {
            path: ':episodeId',
            name: 'healthcare-case-follow-up-episode-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/case-follow-up/[episodeId].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'case-sheets',
        /* internal name: 'healthcare-case-sheets' */
        /* no component */
        children: [
          {
            path: '',
            name: 'healthcare-case-sheets',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/case-sheets/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'clinical-master-data',
        /* internal name: 'healthcare-clinical-master-data' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'healthcare-clinical-master-data',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/clinical-master-data/index.vue'),
            /* no children */
          },
  _definePage_default_17
  ),
          {
            path: 'print',
            /* internal name: 'healthcare-clinical-master-data-print' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'healthcare-clinical-master-data-print',
                component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/clinical-master-data/print/index.vue'),
                /* no children */
              },
  _definePage_default_18
  ),
              {
                path: 'settings',
                /* internal name: 'healthcare-clinical-master-data-print-settings' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'healthcare-clinical-master-data-print-settings',
                    component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/clinical-master-data/print/settings/index.vue'),
                    /* no children */
                  },
  _definePage_default_19
  )
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'coordinator',
        /* internal name: 'healthcare-coordinator' */
        /* no component */
        children: [
          {
            path: '',
            name: 'healthcare-coordinator',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/coordinator/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'coordinator-pilot',
        /* internal name: 'healthcare-coordinator-pilot' */
        /* no component */
        children: [
          {
            path: '',
            name: 'healthcare-coordinator-pilot',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/coordinator-pilot/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'doctor-performance',
        /* internal name: 'healthcare-doctor-performance' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'healthcare-doctor-performance',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/doctor-performance/index.vue'),
            /* no children */
          },
  _definePage_default_20
  )
        ],
      },
      {
        path: 'labs',
        /* internal name: 'healthcare-labs' */
        /* no component */
        children: [
          {
            path: '',
            name: 'healthcare-labs',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/labs/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'healthcare-labs-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/labs/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'pets',
        /* internal name: 'healthcare-pets' */
        /* no component */
        children: [
          {
            path: ':id',
            /* internal name: 'healthcare-pets-id' */
            /* no component */
            children: [
              {
                path: 'cases',
                name: 'healthcare-pets-id-cases',
                component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/pets/[id]/cases.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'pharmacy',
        /* internal name: 'healthcare-pharmacy' */
        /* no component */
        children: [
          {
            path: '',
            name: 'healthcare-pharmacy',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/pharmacy/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'preventive-care',
        /* internal name: 'healthcare-preventive-care' */
        /* no component */
        children: [
          {
            path: '',
            name: 'healthcare-preventive-care',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/preventive-care/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'healthcare-preventive-care-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/preventive-care/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'procedures',
        /* internal name: 'healthcare-procedures' */
        /* no component */
        children: [
          {
            path: '',
            name: 'healthcare-procedures',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/procedures/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'healthcare-procedures-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/procedures/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'radiology',
        /* internal name: 'healthcare-radiology' */
        /* no component */
        children: [
          {
            path: '',
            name: 'healthcare-radiology',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/radiology/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'healthcare-radiology-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/radiology/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'ratings',
        /* internal name: 'healthcare-ratings' */
        /* no component */
        children: [
          {
            path: '',
            name: 'healthcare-ratings',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/ratings/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'service-provider',
        /* internal name: 'healthcare-service-provider' */
        /* no component */
        children: [
          {
            path: '',
            name: 'healthcare-service-provider',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/service-provider/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'services',
        /* internal name: 'healthcare-services' */
        /* no component */
        children: [
          {
            path: '',
            name: 'healthcare-services',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/services/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'healthcare-services-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/services/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'settings',
        /* internal name: 'healthcare-settings' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'healthcare-settings',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/settings/index.vue'),
            /* no children */
          },
  _definePage_default_21
  )
        ],
      },
      {
        path: 'visits',
        /* internal name: 'healthcare-visits' */
        /* no component */
        children: [
          {
            path: '',
            name: 'healthcare-visits',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/visits/index.vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'healthcare-visits-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/healthcare/visits/[id].vue'),
            /* no children */
          },
  _definePage_default_22
  )
        ],
      }
    ],
  },
  {
    path: '/his',
    /* internal name: 'his' */
    /* no component */
    children: [
      {
        path: '',
        name: 'his',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/his/index.vue'),
        /* no children */
      },
      {
        path: 'billing',
        /* internal name: 'his-billing' */
        /* no component */
        children: [
          {
            path: '',
            name: 'his-billing',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/his/billing/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'cardiology',
        /* internal name: 'his-cardiology' */
        /* no component */
        children: [
          {
            path: '',
            name: 'his-cardiology',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/his/cardiology/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'encounters',
        /* internal name: 'his-encounters' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'his-encounters-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/his/encounters/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'front-desk',
        /* internal name: 'his-front-desk' */
        /* no component */
        children: [
          {
            path: '',
            name: 'his-front-desk',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/his/front-desk/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'lab',
        /* internal name: 'his-lab' */
        /* no component */
        children: [
          {
            path: '',
            name: 'his-lab',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/his/lab/index.vue'),
            /* no children */
          },
          {
            path: 'results',
            /* internal name: 'his-lab-results' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'his-lab-results-id',
                component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/his/lab/results/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'patients',
        /* internal name: 'his-patients' */
        /* no component */
        children: [
          {
            path: '',
            name: 'his-patients',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/his/patients/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'his-patients-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/his/patients/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'pharmacy',
        /* internal name: 'his-pharmacy' */
        /* no component */
        children: [
          {
            path: '',
            name: 'his-pharmacy',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/his/pharmacy/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'radiology',
        /* internal name: 'his-radiology' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'his-radiology',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/his/radiology/index.vue'),
            /* no children */
          },
  _definePage_default_23
  )
        ],
      },
      {
        path: 'surgery',
        /* internal name: 'his-surgery' */
        /* no component */
        children: [
          {
            path: '',
            name: 'his-surgery',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/his/surgery/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'visits',
        /* internal name: 'his-visits' */
        /* no component */
        children: [
          {
            path: '',
            name: 'his-visits',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/his/visits/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/hrms',
    /* internal name: 'hrms' */
    /* no component */
    children: [
      {
        path: '',
        name: 'hrms',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/hrms/index.vue'),
        /* no children */
      },
      {
        path: 'attendance',
        /* internal name: 'hrms-attendance' */
        /* no component */
        children: [
          {
            path: '',
            name: 'hrms-attendance',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/hrms/attendance/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'employees',
        /* internal name: 'hrms-employees' */
        /* no component */
        children: [
          {
            path: '',
            name: 'hrms-employees',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/hrms/employees/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'hrms-employees-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/hrms/employees/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'leaves',
        /* internal name: 'hrms-leaves' */
        /* no component */
        children: [
          {
            path: '',
            name: 'hrms-leaves',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/hrms/leaves/index.vue'),
            /* no children */
          },
          {
            path: 'approvals',
            /* internal name: 'hrms-leaves-approvals' */
            /* no component */
            children: [
              {
                path: '',
                name: 'hrms-leaves-approvals',
                component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/hrms/leaves/approvals/index.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'payroll',
        /* internal name: 'hrms-payroll' */
        /* no component */
        children: [
          {
            path: '',
            name: 'hrms-payroll',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/hrms/payroll/index.vue'),
            /* no children */
          },
          {
            path: 'batches',
            /* internal name: 'hrms-payroll-batches' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'hrms-payroll-batches-id',
                component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/hrms/payroll/batches/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'punches',
        /* internal name: 'hrms-punches' */
        /* no component */
        children: [
          {
            path: '',
            name: 'hrms-punches',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/hrms/punches/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'reports',
        /* internal name: 'hrms-reports' */
        /* no component */
        children: [
          {
            path: '',
            name: 'hrms-reports',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/hrms/reports/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/login.vue'),
    /* no children */
  },
  _definePage_default_24
  ),
  {
    path: '/modules',
    /* internal name: 'modules' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'modules',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/modules/index.vue'),
        /* no children */
      },
  _definePage_default_25
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_26
  ),
  {
    path: '/notifications',
    /* internal name: 'notifications' */
    /* no component */
    children: [
      {
        path: '',
        name: 'notifications',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/notifications/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/order',
    /* internal name: 'order' */
    /* no component */
    children: [
      {
        path: 'details',
        /* internal name: 'order-details' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'order-details-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/order/details/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'list',
        name: 'order-list',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/order/list.vue'),
        /* no children */
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/permission',
    name: 'permission',
    component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/permission.vue'),
    /* no children */
  },
  _definePage_default_27
  ),
  {
    path: '/pet-profile',
    /* internal name: 'pet-profile' */
    /* no component */
    children: [
      {
        path: ':id',
        /* internal name: 'pet-profile-id' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':tab',
            name: 'pet-profile-id-tab',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/pet-profile/[id]/[tab].vue'),
            /* no children */
          },
  _definePage_default_28
  )
        ],
      },
      {
        path: 'add',
        /* internal name: 'pet-profile-add' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pet-profile-add',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/pet-profile/add/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'edit',
        /* internal name: 'pet-profile-edit' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'pet-profile-edit-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/pet-profile/edit/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'list',
        /* internal name: 'pet-profile-list' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pet-profile-list',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/pet-profile/list/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/pet-transport',
    /* internal name: 'pet-transport' */
    /* no component */
    children: [
      {
        path: 'me',
        name: 'pet-transport-me',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/pet-transport/me.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/pos',
    /* internal name: 'pos' */
    /* no component */
    children: [
      {
        path: '',
        name: 'pos',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/pos/index.vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: 'offline-queue',
        name: 'pos-offline-queue',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/pos/offline-queue.vue'),
        /* no children */
      },
  _definePage_default_29
  ),
  _mergeRouteRecord(
      {
        path: 'sell',
        name: 'pos-sell',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/pos/sell.vue'),
        /* no children */
      },
  _definePage_default_30
  )
    ],
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/profile.vue'),
    /* no children */
  },
  {
    path: '/qr-search',
    /* internal name: 'qr-search' */
    /* no component */
    children: [
      {
        path: ':kind?',
        /* internal name: 'qr-search-kind?' */
        /* no component */
        children: [
          {
            path: ':id?',
            name: 'qr-search-kind?id?',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/qr-search/[[kind]]/[[id]].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/queue',
    /* internal name: 'queue' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'display',
        name: 'queue-display',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/queue/display.vue'),
        /* no children */
      },
  _definePage_default_31
  ),
  _mergeRouteRecord(
      {
        path: 'doctor',
        name: 'queue-doctor',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/queue/doctor.vue'),
        /* no children */
      },
  _definePage_default_32
  ),
  _mergeRouteRecord(
      {
        path: 'kiosk',
        name: 'queue-kiosk',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/queue/kiosk.vue'),
        /* no children */
      },
  _definePage_default_33
  )
    ],
  },
  {
    path: '/report-engine',
    /* internal name: 'report-engine' */
    /* no component */
    children: [
      {
        path: '',
        name: 'report-engine',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/report-engine/index.vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: ':tab',
        name: 'report-engine-tab',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/report-engine/[tab].vue'),
        /* no children */
      },
  _definePage_default_34
  )
    ],
  },
  {
    path: '/roles',
    name: 'roles',
    component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/roles.vue'),
    /* no children */
  },
  {
    path: '/second-page',
    name: 'second-page',
    component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/second-page.vue'),
    /* no children */
  },
  {
    path: '/setting',
    /* internal name: 'setting' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':tab',
        name: 'setting-tab',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/setting/[tab].vue'),
        /* no children */
      },
  _definePage_default_35
  )
    ],
  },
  {
    path: '/supplier',
    /* internal name: 'supplier' */
    /* no component */
    children: [
      {
        path: 'list',
        /* internal name: 'supplier-list' */
        /* no component */
        children: [
          {
            path: '',
            name: 'supplier-list',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/supplier/list/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/suppliers',
    /* internal name: 'suppliers' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'suppliers',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/suppliers/index.vue'),
        /* no children */
      },
  _definePage_default_36
  ),
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'suppliers-id',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/suppliers/[id].vue'),
        /* no children */
      },
  _definePage_default_37
  )
    ],
  },
  {
    path: '/transporters',
    /* internal name: 'transporters' */
    /* no component */
    children: [
      {
        path: '',
        name: 'transporters',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/transporters/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: 'transporters-id',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/transporters/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/users',
    /* internal name: 'users' */
    /* no component */
    children: [
      {
        path: ':id',
        /* internal name: 'users-id' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'profile',
            name: 'users-id-profile',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/users/[id]/profile.vue'),
            /* no children */
          },
  _definePage_default_38
  )
        ],
      }
    ],
  },
  {
    path: '/visit',
    /* internal name: 'visit' */
    /* no component */
    children: [
      {
        path: '',
        name: 'visit',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/visit/index.vue'),
        /* no children */
      },
      {
        path: 'addOrEdit',
        /* internal name: 'visit-add-or-edit' */
        /* no component */
        children: [
          {
            path: ':id?',
            name: 'visit-add-or-edit-id?',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/visit/addOrEdit/[[id]].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/vst-test-page',
    /* internal name: 'vst-test-page' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'vst-test-page',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/vst-test-page/index.vue'),
        /* no children */
      },
  _definePage_default_39
  ),
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'vst-test-page-id',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/vst-test-page/[id].vue'),
        /* no children */
      },
  _definePage_default_40
  )
    ],
  },
  {
    path: '/warehouse',
    /* internal name: 'warehouse' */
    /* no component */
    children: [
      {
        path: '',
        name: 'warehouse',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: 'warehouse-id',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/[id].vue'),
        /* no children */
      },
      {
        path: 'item-prices',
        /* internal name: 'warehouse-item-prices' */
        /* no component */
        children: [
          {
            path: '',
            name: 'warehouse-item-prices',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/item-prices/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'item-units',
        /* internal name: 'warehouse-item-units' */
        /* no component */
        children: [
          {
            path: '',
            name: 'warehouse-item-units',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/item-units/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'items',
        /* internal name: 'warehouse-items' */
        /* no component */
        children: [
          {
            path: '',
            name: 'warehouse-items',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/items/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'warehouse-items-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/items/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'purchase-invoices',
        /* internal name: 'warehouse-purchase-invoices' */
        /* no component */
        children: [
          {
            path: '',
            name: 'warehouse-purchase-invoices',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/purchase-invoices/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'warehouse-purchase-invoices-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/purchase-invoices/[id].vue'),
            /* no children */
          },
          {
            path: 'create',
            name: 'warehouse-purchase-invoices-create',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/purchase-invoices/create.vue'),
            /* no children */
          }
        ],
      },
  _mergeRouteRecord(
      {
        path: 'returns-monitor',
        name: 'warehouse-returns-monitor',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/returns-monitor.vue'),
        /* no children */
      },
  _definePage_default_41
  ),
  _mergeRouteRecord(
      {
        path: 'smart-dashboard',
        name: 'warehouse-smart-dashboard',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/smart-dashboard.vue'),
        /* no children */
      },
  _definePage_default_42
  ),
  _mergeRouteRecord(
      {
        path: 'stock-checker',
        name: 'warehouse-stock-checker',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-checker.vue'),
        /* no children */
      },
  _definePage_default_43
  ),
  _mergeRouteRecord(
      {
        path: 'stock-count',
        name: 'warehouse-stock-count',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-count.vue'),
        /* no children */
      },
  _definePage_default_44
  ),
      {
        path: 'stock-entries',
        /* internal name: 'warehouse-stock-entries' */
        /* no component */
        children: [
          {
            path: '',
            name: 'warehouse-stock-entries',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-entries/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'warehouse-stock-entries-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-entries/[id].vue'),
            /* no children */
          },
          {
            path: 'create',
            name: 'warehouse-stock-entries-create',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-entries/create.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'stock-ledger',
        name: 'warehouse-stock-ledger',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-ledger.vue'),
        /* no children */
      },
      {
        path: 'stock-prices',
        /* internal name: 'warehouse-stock-prices' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'warehouse-stock-prices',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-prices/index.vue'),
            /* no children */
          },
  _definePage_default_45
  ),
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'warehouse-stock-prices-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-prices/[id].vue'),
            /* no children */
          },
  _definePage_default_46
  ),
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'warehouse-stock-prices-create',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-prices/create.vue'),
            /* no children */
          },
  _definePage_default_47
  )
        ],
      },
      {
        path: 'stock-reconciliations',
        /* internal name: 'warehouse-stock-reconciliations' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'warehouse-stock-reconciliations',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-reconciliations/index.vue'),
            /* no children */
          },
  _definePage_default_48
  ),
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'warehouse-stock-reconciliations-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-reconciliations/[id].vue'),
            /* no children */
          },
  _definePage_default_49
  ),
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'warehouse-stock-reconciliations-create',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-reconciliations/create.vue'),
            /* no children */
          },
  _definePage_default_50
  )
        ],
      },
      {
        path: 'stock-transfers',
        /* internal name: 'warehouse-stock-transfers' */
        /* no component */
        children: [
          {
            path: '',
            name: 'warehouse-stock-transfers',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-transfers/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'warehouse-stock-transfers-id',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-transfers/[id].vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: 'new',
            name: 'warehouse-stock-transfers-new',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-transfers/new.vue'),
            /* no children */
          },
  _definePage_default_51
  ),
          {
            path: 'settings',
            name: 'warehouse-stock-transfers-settings',
            component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/warehouse/stock-transfers/settings.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/whatsapp',
    /* internal name: 'whatsapp' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'whatsapp',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/whatsapp/index.vue'),
        /* no children */
      },
  _definePage_default_52
  ),
  _mergeRouteRecord(
      {
        path: ':tab',
        name: 'whatsapp-tab',
        component: () => import('/home/runner/work/alkhokh_pet_store_front/alkhokh_pet_store_front/src/pages/whatsapp/[tab].vue'),
        /* no children */
      },
  _definePage_default_53
  )
    ],
  }
]
